import React, { useState } from 'react'
import { Box, CircularProgress, CssBaseline } from '@mui/material'

import './Dashboard.css'

import { useNavigate } from 'react-router'
import DashboardPage from './components/Dashboard/DashboardPage'
import AppBarComp from './components/Appbar/AppbarComp'
import Sidebar from './components/Sidebar/Sidebar'
import School from './components/Pages/School/School'
import Employee from './components/Pages/Employee/Employee'
import Student from './components/Pages/Student/Student'
import Teacher from './components/Pages/Teacher/Teacher'
import { ToastContainer } from 'react-toastify'
import Profile from './components/Pages/Profile/Profile'
import Fees from './components/Pages/Fees/Fees'
import Class from './components/Pages/Class/Class'
import { Expense } from './components/Pages/Expense/Expense'
import { useDispatch, useSelector } from 'react-redux'
import { Route } from './components/Pages/Routes/Route'
import { VanDriver } from './components/Pages/VanDriver/VanDriver'
import { VanList } from './components/Pages/Van/Van'
import { Sales } from './components/Pages/Sales/Sales'
import { Auth } from 'aws-amplify'
import { ImportBox } from '../../components/ImportBox/ImportBox'
import { setLoader, setOpenImport, setisAuthenticated } from '../../redux/globalSlice'
import HelpSupport from './components/Pages/HelpSupport'
import Credits from './components/Pages/Credits/Credits'
import Holidays from './components/Pages/Holidays/Holidays'
import StudentList from './components/Pages/StudentList/Student'
import StudentPresence from './components/Pages/StudentPresence/Student'
import EmployeePresence from './components/Pages/EmployeePresence/EmployeePresence'
import TimeTable from './components/Pages/TimeTable/TimeTable'
import Subject from './components/Pages/Subject/Subject'

const Dashboard = () => {
  const { loader, openImport, inExpense, creditOpen } = useSelector((state) => state.global)
  const dispatch = useDispatch()
  const [selectedComponent, setSelectedComponent] = useState('Dashboard')
  const navigate = useNavigate()

  // console.log('---selectedComponent', selectedComponent)

  const handleLogout = async () => {
    try {
      dispatch(setLoader(true))
      await Auth.signOut()
      localStorage.removeItem('userAttributes')
      localStorage.removeItem('userSchoolId')
      dispatch(setisAuthenticated(false))
      navigate('/')
    } catch (error) {
      dispatch(setLoader(false))
      console.error('Error signing out:', error)
    } finally {
      dispatch(setLoader(false))
    }
  }

  const renderSelectedComponent = () => {
    switch (selectedComponent) {
      case 'Dashboard':
        return <DashboardPage />
      case 'Sales Analytics':
        return <Sales />
      case 'School':
        return <School />
      case 'Class':
        return <Class />
      case 'Employee':
        return <Employee />
      case 'Student':
        return <Student />
      case 'Teacher':
        return <Teacher />
      case 'Fees':
        return <Fees />
      case 'Expenses':
        return <Expense />
      case 'Routes':
        return <Route />
      case 'Profile':
        return <Profile />
      case 'Van':
        return <VanList />
      case 'Van Driver':
        return <VanDriver />
      case 'Help & Support':
        return <HelpSupport />
      case 'Holidays':
        return <Holidays />
      case 'Student List':
        return <StudentList />
      case 'Student Presence':
        return <StudentPresence />
      case 'Employee Presence':
        return <EmployeePresence />
      case 'Time Table':
        return <TimeTable />
      case 'Subject':
        return <Subject />
      case 'Logout':
        handleLogout()
        return null
      default:
        return null
    }
  }

  return (
    <Box className="dashboard-container">
      <CssBaseline />
      <ToastContainer />
      <AppBarComp setSelectedComponent={setSelectedComponent} />
      <Sidebar selectedComponent={selectedComponent} setSelectedComponent={setSelectedComponent} />
      {loader && (
        <div className="circular-box" style={{ height: inExpense ? '100dvh' : '100dvh' }}>
          <CircularProgress />
        </div>
      )}
      {openImport && (
        <ImportBox open={openImport} handleClose={() => dispatch(setOpenImport(false))} />
      )}
      {creditOpen ? (
        <Box className="main-comp">
          <Credits />
        </Box>
      ) : (
        <Box className="main-comp">{renderSelectedComponent()}</Box>
      )}
    </Box>
  )
}

export default Dashboard
